// External dependencies.
import PropTypes from "prop-types";
import React from "react";

// Internal dependencies.
import logo from "../../images/logoColor.svg";
import Link from "../Link";

import * as styles from "./styles.module.scss";

/**
 * @param {Object} props Component props.
 * @param {String} props.alt The alternative text to show for the logo.
 * @returns {ReactElement} A react component describing the logo component.
 * @constructor
 */
export function Logo( props ) {
	switch ( props.context ) {
		case "header":
		case "sidebar":
			return (
				<Link to="/" className={ styles.logo }>
					{ /* React 18 only forwards the lowercase `fetchpriority` attribute to the DOM;
					     camelCase `fetchPriority` is dropped with a warning (that changes in React 19).
					     When upgrading React, this next eslint-disable line will not have any effect, which
					     results in another warning from eslint, highlighting this can be changed back to `fetchPriority` */ }
					{ /* eslint-disable react/no-unknown-property */ }
					<img
						src={ logo } width="200" height="58" decoding="async" fetchpriority="high"
						alt={ props.alt }
					/>
					{ /* eslint-enable react/no-unknown-property */ }
				</Link>
			);
	}
}

Logo.propTypes = {
	alt: PropTypes.string,
	context: PropTypes.string.isRequired,
};

Logo.defaultProps = {
	alt: "Home page",
};
